import { Injectable } from '@angular/core';
// import { IssueReportModalComponent } from '@wephone-app-phone/modals/issue-report/issue-report-modal.component';
import { HttpEngine } from '@wephone-core/service/http_engine';
import { DialogService } from '@wephone-utils';

@Injectable()
export class IssueReportService {
  private readonly ADD_ISSUE_REPORT_URL = 'user/report-issue';

  constructor(
    private readonly httpEngine: HttpEngine,
    private readonly dialogService: DialogService,
  ) {
  }

  showReportDialog(call_id?: number): void {
    // this.dialogService.openDialog2(IssueReportModalComponent, { data: { call_id }, size: 's' });
  }

  add(data: any): Promise<any> {
    return this.httpEngine.apiPostV2(this.ADD_ISSUE_REPORT_URL, data);
  }
}
